import { Distance, Line, Point } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Check for collisions between collision trees
 */
export default class PolygonCollisionChecker {
    /**
     * Check if given point is in a polygon, defined by given lines. The
     * given lines must specify a closed polygon. Otherwise this method
     * can't do a good job.
     *
     * @param {Point} point Point to be checked
     * @param {Line[]} lines Lines to specify polygon
     * @param {Point} [yInitialDistance] on y-axis (only for recursion)
     *
     * @return {boolean} True if point is in polygon
     */
    isPointInPoly(point, lines, yInitialDistance = null) {
        const xDistance = 9999999;
        const yDistanceStepSize = xDistance / 90;
        const yDistance = yInitialDistance || yDistanceStepSize;
        let inPoly = false;

        const distance = new Distance(xDistance, yDistance);
        const testLine = new Line(point, point.clone().move(distance));

        for (let i = lines.length - 1; i >= 0; i -= 1) {
            const line = lines[i];

            // if the point is exactly on a line the point is always considered to be "outside" of the polygon
            if (line.containsPoint(point)) return false;

            const intersection = line.intersect(testLine);

            if (intersection instanceof Point && this._isStartOrEndPoint(intersection, line)) {
                return this.isPointInPoly(point, lines, yDistance + yDistanceStepSize);
            }

            if (intersection) inPoly = !inPoly;
        }

        return inPoly;
    }

    /**
     * Check if a point is inside a polygon
     *
     * @param {Point} point
     * @param {Line} line
     * @return {boolean}
     * @private
     */
    _isStartOrEndPoint(point, line) {
        return point.equal(line.startPoint) || point.equal(line.endPoint);
    }
}
